import ModalHeader from './component';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { fetchPositions } from 'redux/modules/journey-map/effects';
import { getItem, getItemType, getFetching } from 'redux/modules/journey-map/selectors';

const enhance = compose(
  connect(
    (state) => ({
      idType: getItemType(state),
      item: getItem(state),
      fetchingPositions: getFetching(state, 'positions'),
    }),
    {
      onRefreshClick: fetchPositions,
    }
  )
);

export default enhance(ModalHeader);
